(function() {
    
    var $newAddressForm = $('#AddressNewForm')
    
    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hidden')
    })

    $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id')
        console.log($('#EditAddress_' + formId))
        $('#EditAddress_' + formId).toggleClass('hidden')
    })

    $('.address-delete').on('click', function() {
        var $el = $(this)
        var formId = $el.data('form-id')
        var confirmMessage = $el.data('confirm-message')
        // eslint-disable-next-line no-alert
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {
                parameters: {
                    _method: 'delete'
                }
            })
        }
    })

    // Save existing sort parameters
    Shopify.queryParams = {};
    if(location.search.length) {
        for(var aKeyValue, i = 0, aCouples = location.search.substring(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
        }
    }

    // Add existing sort parameters to current URL
    var sortBy = document.querySelector('#SortBy')
    if (sortBy) {
        sortBy.addEventListener('change', function(e) {
            var value = e.currentTarget.value;
            Shopify.queryParams.sort_by = value;
            location.search = new URLSearchParams(Shopify.queryParams).toString();
        });
    }

    // Add existing sort parameters to current URL
    var productNo = document.querySelector('#ProductNo')
    if (productNo) {
        productNo.addEventListener('change', function(e) {
            var value = e.currentTarget.value;
            Shopify.queryParams.view = value;
            location.search = new URLSearchParams(Shopify.queryParams).toString();
        });
    }
// Your Glide initialization code here
// document.addEventListener('DOMContentLoaded', function() {
//     if (document.querySelector('.glide-product-images')) { // Checks if the element exists
//         new Glide('.glide-product-images', {
//             perView: 1,
//             animationDuration: 350,
//             // other configurations
//         }).mount();
//     }


// });
})();